var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-son",class:{fill: _vm.fill,auto: _vm.auto,center: _vm.center},style:('right: '+_vm.right+';top: '+_vm.top+';bottom:'+_vm.bottom+';left:'+_vm.left+';')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }